import { Outlet, Link, useLocation } from 'react-router-dom'
import Logo from './Logo'
import WalletConnectButton from './WalletConnectButton'
import { WalletProvider } from '../wallet/WalletProvider'

function TopNav() {
  const location = useLocation()
  const isMedia = location.pathname.startsWith('/media')
  const isPayments = location.pathname.startsWith('/payments')
  const isDocs = location.pathname.startsWith('/docs')
  return (
    <header className="sticky top-0 z-30 border-b border-white/10 bg-bg/70 backdrop-blur">
      <div className="container-x flex h-16 items-center justify-between">
        <Link to="/" className="no-underline">
          <Logo />
        </Link>
        <nav className="hidden items-center gap-6 md:flex">
          <Link className={isPayments ? 'text-white' : 'link'} to="/payments">
            Demo
          </Link>
          <Link className={isDocs ? 'text-white' : 'link'} to="/docs">
            Docs
          </Link>
          <Link className={isMedia ? 'text-white' : 'link'} to="/media">
            Media
          </Link>
        </nav>
        <div className="flex items-center gap-3">
          <WalletConnectButton />
          <a
            className="rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm text-white/80 transition hover:bg-white/10 hover:text-white"
            href="/#cta"
          >
            Contact
          </a>
        </div>
      </div>
    </header>
  )
}

function Footer() {
  return (
    <footer className="border-t border-white/10 bg-bg">
      <div className="container-x py-10">
        <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
          <div className="text-sm text-white/60">
            <div className="font-medium text-white/80">Soulon</div>
            <div>Build the settlement layer for multi-chain experiences.</div>
          </div>
          <div className="flex items-center gap-5 text-sm">
            <Link className="link" to="/payments">
              Payment Demo
            </Link>
            <Link className="link" to="/docs">
              Docs
            </Link>
            <a className="link" href="/#personality-memory">
              Personality Memory
            </a>
            <a className="link" href="/#how">
              How it works
            </a>
            <a className="link" href="/#roadmap">
              Roadmap
            </a>
            <a className="link" href="/#cta">
              Contact
            </a>
            <Link className="link" to="/media">
              Media Kit
            </Link>
          </div>
        </div>
        <div className="mt-6 text-xs text-white/40">
          © {new Date().getFullYear()} Soulon. All rights reserved.
        </div>
      </div>
    </footer>
  )
}

export default function Layout() {
  return (
    <WalletProvider>
      <div className="min-h-screen bg-bg text-white">
        <TopNav />
        <Outlet />
        <Footer />
      </div>
    </WalletProvider>
  )
}
